import type { DataPoint } from "~/tools/data-point";
import type { Time } from "~/tools/date-time/time";
import { isPresent } from "~/tools/is-present";
import { max } from "~/tools/max";
import { mean } from "~/tools/mean";
import { min } from "~/tools/min";
import { prop } from "~/tools/prop";
import { sum } from "~/tools/sum";

import { ALL_SINGLE_POINT_CALCULATIONS, calculateSinglePoint, isSinglePointCalculation } from "./single-point";

export const ALL_CALCULATIONS = ["mean", ...ALL_SINGLE_POINT_CALCULATIONS, "sum", "min", "max"] as const;

export type Calculation = (typeof ALL_CALCULATIONS)[number];

export function calculateValueFromPoints(
	calculation: Time | Calculation,
	points: ReadonlyArray<DataPoint>,
): undefined | number {
	if (isSinglePointCalculation(calculation)) {
		const point = calculateSinglePoint(calculation, points);

		return point?.[1] ?? undefined;
	}

	const values = points.map(prop(1));

	switch (calculation) {
		case "mean": {
			return mean(values);
		}

		case "min": {
			return min(values);
		}

		case "max": {
			return max(values);
		}

		case "sum": {
			return sum(values.filter(isPresent));
		}
	}
}
